import Alert from "../atoms/Alert/Alert";

export const FallbackError = () => (
    <Alert
        variant="error"
        title="Something went wrong. Please reach out to Snowflake support."
    />
);
